import { colors } from '../style'

export default function getThemeColor(themeMode) {
  if (themeMode === 'Light') return colors.light
  if (themeMode === 'Dark') return colors.dark

  return colors.light
}
